<app-dialog
  #dialog
  [key]="'send-meeting-bot'"
  [action]="'send-meeting-bot'"
  [headerTheme]="'simple'"
  [title]="'Adicionar bot na call'"
  [maxWidth]="'600px'">
  <div class="send-bot">
    <p class="send-bot__hint">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>
        Para reuniões que não estão na agenda de quem conectou a conta Microsoft. O "Cog AI bot"
        entra, grava e a reunião aparece aqui com gravação e transcrição.
      </span>
    </p>

    <app-input
      [label]="'Link da reunião'"
      [placeholder]="'https://teams.microsoft.com/l/meetup-join/...'"
      [textCenter]="false"
      [required]="true"
      [(ngModel)]="link" />

    <app-input
      [label]="'Título (opcional)'"
      [placeholder]="'Ex.: Call com o Banco X'"
      [textCenter]="false"
      [(ngModel)]="titulo" />

    <app-switch
      [label]="'Agendar para um horário'"
      [checked]="agendar()"
      (sendChecked)="alternarAgendamento($event)" />

    @if (agendar()) {
      <div class="send-bot__horario">
        <app-calendar [label]="'Dia'" [minDate]="hoje()" [(ngModel)]="dia" />
        <app-input
          [label]="'Hora (Brasília)'"
          [placeholder]="'15:00'"
          [mask]="'99:99'"
          [(ngModel)]="hora" />
      </div>
    } @else {
      <p class="send-bot__muted">O bot tenta entrar na reunião agora.</p>
    }

    <p class="send-bot__secao">Vincular (opcional)</p>
    <app-meeting-link-fields #campos (selecaoChange)="vinculos.set($event)" />
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="fechar()" />
      <app-button
        [label]="agendar() ? 'Agendar bot' : 'Enviar bot agora'"
        [icon]="'pi pi-video'"
        [disabled]="!isFormValid()"
        [isLoading]="gravando()"
        [loadingText]="'Enviando...'"
        [type]="'button'"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
